import React from 'react';
import { FormHelperText } from '@mui/material';

import './FieldError.scss';

const FieldError = ({ error, id }) => (
  <FormHelperText
    id={id}
    role={error ? 'alert' : undefined}
    className="fieldError"
  >
    {error ?? ' '}
  </FormHelperText>
);

export default FieldError;
